import React from 'react'
import { useAuth0 } from '../react-auth0-spa'

const LogoutRoute = () => {
  // remove the dev hostname cookie on logout
  document.cookie = 'loginHostName=; Max-Age=-99999999;'
  const { logout } = useAuth0()
  logout({returnTo: encodeURI(window.location.origin)})
  return () => <div>Logging out</div>
}

export default LogoutRoute
